<template>
    <div class="login-container">
        <div class="login-container-vertical-center">
            <div v-if="step == '1_member_id'">
                <div class="text-center" style="display: flex">
                    <img src="../../../../../../public/resources/images/logo.png" style="width: 70%; margin: 0 auto" />
                </div>
                <a-form class="mb-4" :form="form" @submit="handleSubmit">
                    <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol2" class="ant-label-title-custom" style="text-align: center">
                        <span class="fs-18 black fw-600">หมายเลขสมาชิก / Member ID</span>
                        <a-input
                            size="large"
                            placeholder="หมายเลขสมาชิก 11 หลัก"
                            :maxLength="11"
                            v-decorator="[
                                'username',
                                {
                                    initialValue: username,
                                    rules: [
                                        {
                                            required: false,
                                            message: '',
                                        },
                                    ],
                                },
                            ]"
                            style="width: 100% !important"
                        />
                    </a-form-item>
                    <a-button htmlType="submit" size="large" class="text-center w-100 bg-red br-20" :loading="loading_1_member_id">
                        <span class="fs-18 color-white fw-600">ยืนยัน</span>
                    </a-button>
                    <div class="footer-label text-center mt-20" @click="goToStep(10)">
                        <span class="fs-18 red fw-600">ลืมหมายเลขสมาชิก</span>
                    </div>
                </a-form>
            </div>
            <div v-if="step == '2_password'" :class="'container-password is-' + $device">
                <label class="fs-18" style="display: block">
                    {{ member.custodian_name }}
                </label>
                <label class="fs-24" style="margin-bottom: 12px"> กรุณากรอกรหัส PIN 6 หลัก</label>
                <div class="dots-width">
                    <span
                        class="dot animated"
                        :style="{
                            'margin-left': 0,
                            'background-color': password.length > 0 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': password.length > 1 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': password.length > 2 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': password.length > 3 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': password.length > 4 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': password.length > 5 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                </div>
                <div class="footer-label ลืมรหัส" @click="goToStep(3)">
                    <span class="fs-18 fw-600 red">ลืมรหัส PIN</span>
                </div>
                <div class="pins">
                    <div class="pinC animated bounceInUp">
                        <div class="pinB" nr="1" @click="onPinPress(1)">
                            <label class="pin_T fs-32">1</label>
                        </div>
                        <div class="pinB" nr="2" @click="onPinPress(2)">
                            <label class="pin_T fs-32">2</label>
                        </div>
                        <div class="pinB" nr="3" @click="onPinPress(3)">
                            <label class="pin_T fs-32">3</label>
                        </div>
                        <div class="pinB" nr="4" @click="onPinPress(4)">
                            <label class="pin_T fs-32">4</label>
                        </div>
                        <div class="pinB" nr="5" @click="onPinPress(5)">
                            <label class="pin_T fs-32">5</label>
                        </div>
                        <div class="pinB" nr="6" @click="onPinPress(6)">
                            <label class="pin_T fs-32">6</label>
                        </div>
                        <div class="pinB" nr="7" @click="onPinPress(7)">
                            <label class="pin_T fs-32">7</label>
                        </div>
                        <div class="pinB" nr="8" @click="onPinPress(8)">
                            <label class="pin_T fs-32">8</label>
                        </div>
                        <div class="pinB" nr="9" @click="onPinPress(9)">
                            <label class="pin_T fs-32">9</label>
                        </div>
                        <div class="pinB"></div>
                        <div class="pinB" nr="0" @click="onPinPress(0)">
                            <label class="pin_T fs-32">0</label>
                        </div>
                        <div class="pinB pDelete" @click="onPinPress('del')">
                            <img src="../../../../../../public/resources/images/delete.png" class="pin_T" style="width: 35%; margin: 0 auto" />
                        </div>
                    </div>
                </div>
                <a-button size="large" class="text-center cancel-btn br-20" style="width: 47.5%" @click="goToStep(1)">
                    <span class="fs-18 fw-600">ยกเลิก</span>
                </a-button>
                <a-button size="large" class="text-center primary-btn" style="width: 47.5%; margin-left: 5%" :loading="loading" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">เข้าสู่ระบบ</span>
                </a-button>
                <div class="footer-label เข้าใช้งานด้วยหมายเลขสมาชิกอื่น" @click="goToStep(1)">
                    <span class="fs-18 fw-600 red">เข้าใช้งานด้วยหมายเลขสมาชิกอื่น</span>
                </div>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '3_forgot_password'" :class="'container_forgot_password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 20px"> ลืมรหัส PIN </label><br />
                <label class="fs-18" style="font-weight: 300; margin-bottom: 20px">
                    <strong>การเปลี่ยนแปลงรหัส PIN จำเป็นต้องยืนยันตัวตนของท่าน เพื่อความปลอดภัยของข้อมูล </strong>
                </label>
                <label class="fs-18" style="font-weight: 300; margin-bottom: 20px">
                    <strong>
                        รหัส OTP จะถูกส่งไปยังเบอร์โทรศัพท์
                        <span class="red" style="display: block; text-align: center" v-if="member.mobile && member.mobile != 'xxx-xxx-'">{{ member.mobile }}</span>
                        <span class="red" style="display: block; text-align: center" v-else>ไม่พบเบอร์มือถือในระบบ</span>
                        <span style="display: block">หากท่านต้องการเพิ่ม/แก้ไขเบอร์โทรศัพท์ </span>
                        <span style="display: block">กรุณาติดต่อเจ้าหน้าที่ 0-2586-2112 กด 0</span>
                        <span style="display: block">ในวันและเวลาทำการ</span>
                    </strong>
                </label>
                <!-- <a-button size="large" class="text-center cancel-btn br-20" style="width: 47.5%" @click="goToStep(2)">
                <span class="fs-18">ยกเลิก</span>
            </a-button>
            <div v-if="member.mobile && member.mobile != 'xxx-xxx-'" class="text-center w-50 primary-btn" style="margin: 0 auto" @click="goToStep(4)">
                <strong class="fs-18">ขอรับ OTP</strong>
            </div> -->
                <a-button size="large" class="text-center cancel-btn br-20" style="width: 47.5%" @click="step = '2_password'">
                    <span class="fs-18 fw-600">ยกเลิก</span>
                </a-button>
                <a-button v-if="member.mobile && member.mobile != 'xxx-xxx-'" size="large" class="text-center primary-btn" style="width: 47.5%; margin-left: 5%" @click="goToStep(4)">
                    <span class="fs-18 color-white fw-600">ขอรับ OTP</span>
                </a-button>
            </div>
            <div v-if="step == '4_otp'" :class="'container-password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 40px"> กรุณากรอกรหัส OTP </label>
                <div style="width: 100%">
                    <span
                        class="dot animated"
                        :style="{
                            'margin-left': 0,
                            'background-color': otp.length > 0 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 1 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 2 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 3 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 4 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 5 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                </div>
                <div class="pins">
                    <div class="pinC animated bounceInUp">
                        <div class="pinB" nr="1" @click="onPinPress(1)">
                            <label class="pin_T fs-32">1</label>
                        </div>
                        <div class="pinB" nr="2" @click="onPinPress(2)">
                            <label class="pin_T fs-32">2</label>
                        </div>
                        <div class="pinB" nr="3" @click="onPinPress(3)">
                            <label class="pin_T fs-32">3</label>
                        </div>
                        <div class="pinB" nr="4" @click="onPinPress(4)">
                            <label class="pin_T fs-32">4</label>
                        </div>
                        <div class="pinB" nr="5" @click="onPinPress(5)">
                            <label class="pin_T fs-32">5</label>
                        </div>
                        <div class="pinB" nr="6" @click="onPinPress(6)">
                            <label class="pin_T fs-32">6</label>
                        </div>
                        <div class="pinB" nr="7" @click="onPinPress(7)">
                            <label class="pin_T fs-32">7</label>
                        </div>
                        <div class="pinB" nr="8" @click="onPinPress(8)">
                            <label class="pin_T fs-32">8</label>
                        </div>
                        <div class="pinB" nr="9" @click="onPinPress(9)">
                            <label class="pin_T fs-32">9</label>
                        </div>
                        <div class="pinB"></div>
                        <div class="pinB" nr="0" @click="onPinPress(0)">
                            <label class="pin_T fs-32">0</label>
                        </div>
                        <div class="pinB pDelete" @click="onPinPress('del')">
                            <img src="../../../../../../public/resources/images/delete.png" class="pin_T" style="width: 35%; margin: 0 auto" />
                        </div>
                    </div>
                </div>
                <a-button size="large" class="text-center cancel-btn br-20" style="width: 47.5%" @click="step_check == 'check_pin_false' ? goToStep(1) : goToStep(3)">
                    <span class="fs-18 fw-600">ยกเลิก</span>
                </a-button>
                <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '5_create_new_password'" :class="'container-password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 40px">กรุณาตั้งรหัส PIN ใหม่</label>
                <div style="width: 100%">
                    <span
                        class="dot animated"
                        :style="{
                            'margin-left': 0,
                            'background-color': new_password.length > 0 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 1 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 2 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 3 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 4 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 5 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                </div>
                <div class="pins">
                    <div class="pinC animated bounceInUp">
                        <div class="pinB" nr="1" @click="onPinPress(1)">
                            <label class="pin_T fs-32">1</label>
                        </div>
                        <div class="pinB" nr="2" @click="onPinPress(2)">
                            <label class="pin_T fs-32">2</label>
                        </div>
                        <div class="pinB" nr="3" @click="onPinPress(3)">
                            <label class="pin_T fs-32">3</label>
                        </div>
                        <div class="pinB" nr="4" @click="onPinPress(4)">
                            <label class="pin_T fs-32">4</label>
                        </div>
                        <div class="pinB" nr="5" @click="onPinPress(5)">
                            <label class="pin_T fs-32">5</label>
                        </div>
                        <div class="pinB" nr="6" @click="onPinPress(6)">
                            <label class="pin_T fs-32">6</label>
                        </div>
                        <div class="pinB" nr="7" @click="onPinPress(7)">
                            <label class="pin_T fs-32">7</label>
                        </div>
                        <div class="pinB" nr="8" @click="onPinPress(8)">
                            <label class="pin_T fs-32">8</label>
                        </div>
                        <div class="pinB" nr="9" @click="onPinPress(9)">
                            <label class="pin_T fs-32">9</label>
                        </div>
                        <div class="pinB"></div>
                        <div class="pinB" nr="0" @click="onPinPress(0)">
                            <label class="pin_T fs-32">0</label>
                        </div>
                        <div class="pinB pDelete" @click="onPinPress('del')">
                            <img src="../../../../../../public/resources/images/delete.png" class="pin_T" style="width: 35%; margin: 0 auto" />
                        </div>
                    </div>
                </div>
                <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '6_confirm_new_password'" :class="'container-password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 40px"> ยืนยันรหัส PIN </label>
                <div style="width: 100%">
                    <span
                        class="dot animated"
                        :style="{
                            'margin-left': 0,
                            'background-color': new_password_confirm.length > 0 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 1 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 2 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 3 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 4 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 5 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                </div>
                <div class="pins">
                    <div class="pinC animated bounceInUp">
                        <div class="pinB" nr="1" @click="onPinPress(1)">
                            <label class="pin_T fs-32">1</label>
                        </div>
                        <div class="pinB" nr="2" @click="onPinPress(2)">
                            <label class="pin_T fs-32">2</label>
                        </div>
                        <div class="pinB" nr="3" @click="onPinPress(3)">
                            <label class="pin_T fs-32">3</label>
                        </div>
                        <div class="pinB" nr="4" @click="onPinPress(4)">
                            <label class="pin_T fs-32">4</label>
                        </div>
                        <div class="pinB" nr="5" @click="onPinPress(5)">
                            <label class="pin_T fs-32">5</label>
                        </div>
                        <div class="pinB" nr="6" @click="onPinPress(6)">
                            <label class="pin_T fs-32">6</label>
                        </div>
                        <div class="pinB" nr="7" @click="onPinPress(7)">
                            <label class="pin_T fs-32">7</label>
                        </div>
                        <div class="pinB" nr="8" @click="onPinPress(8)">
                            <label class="pin_T fs-32">8</label>
                        </div>
                        <div class="pinB" nr="9" @click="onPinPress(9)">
                            <label class="pin_T fs-32">9</label>
                        </div>
                        <div class="pinB"></div>
                        <div class="pinB" nr="0" @click="onPinPress(0)">
                            <label class="pin_T fs-32">0</label>
                        </div>
                        <div class="pinB pDelete" @click="onPinPress('del')">
                            <img src="../../../../../../public/resources/images/delete.png" class="pin_T" style="width: 35%; margin: 0 auto" />
                        </div>
                    </div>
                </div>
                <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '7_id_card'" :class="'container-password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 40px"> กรอกเลขบัตรประชาชน </label>
                <a-form class="mb-4" :form="form" @submit="handleSubmit">
                    <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" class="ant-label-title-custom">
                        <a-input
                            size="large"
                            :maxLength="13"
                            v-decorator="[
                                'card_id',
                                {
                                    initialValue: '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '',
                                        },
                                    ],
                                },
                            ]"
                            style="width: 100%"
                        />
                    </a-form-item>
                    <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                        <span class="fs-18 color-white fw-600">ยืนยัน</span>
                    </a-button>
                </a-form>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '8_change_pin'" :class="'container-password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 40px"> สร้างรหัส PIN </label>
                <div style="width: 100%">
                    <span
                        class="dot animated"
                        :style="{
                            'margin-left': 0,
                            'background-color': new_password.length > 0 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 1 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 2 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 3 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 4 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password.length > 5 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                </div>
                <div class="pins">
                    <div class="pinC animated bounceInUp">
                        <div class="pinB" nr="1" @click="onPinPress(1)">
                            <label class="pin_T fs-32">1</label>
                        </div>
                        <div class="pinB" nr="2" @click="onPinPress(2)">
                            <label class="pin_T fs-32">2</label>
                        </div>
                        <div class="pinB" nr="3" @click="onPinPress(3)">
                            <label class="pin_T fs-32">3</label>
                        </div>
                        <div class="pinB" nr="4" @click="onPinPress(4)">
                            <label class="pin_T fs-32">4</label>
                        </div>
                        <div class="pinB" nr="5" @click="onPinPress(5)">
                            <label class="pin_T fs-32">5</label>
                        </div>
                        <div class="pinB" nr="6" @click="onPinPress(6)">
                            <label class="pin_T fs-32">6</label>
                        </div>
                        <div class="pinB" nr="7" @click="onPinPress(7)">
                            <label class="pin_T fs-32">7</label>
                        </div>
                        <div class="pinB" nr="8" @click="onPinPress(8)">
                            <label class="pin_T fs-32">8</label>
                        </div>
                        <div class="pinB" nr="9" @click="onPinPress(9)">
                            <label class="pin_T fs-32">9</label>
                        </div>
                        <div class="pinB"></div>
                        <div class="pinB" nr="0" @click="onPinPress(0)">
                            <label class="pin_T fs-32">0</label>
                        </div>
                        <div class="pinB pDelete" @click="onPinPress('del')">
                            <img src="../../../../../../public/resources/images/delete.png" class="pin_T" style="width: 35%; margin: 0 auto" />
                        </div>
                    </div>
                </div>
                <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '9_confirm_change_pin'" :class="'container-password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 40px"> สร้างรหัส PIN (อีกครั้ง) </label>
                <div style="width: 100%">
                    <span
                        class="dot animated"
                        :style="{
                            'margin-left': 0,
                            'background-color': new_password_confirm.length > 0 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 1 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 2 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 3 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 4 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': new_password_confirm.length > 5 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                </div>
                <div class="pins">
                    <div class="pinC animated bounceInUp">
                        <div class="pinB" nr="1" @click="onPinPress(1)">
                            <label class="pin_T fs-32">1</label>
                        </div>
                        <div class="pinB" nr="2" @click="onPinPress(2)">
                            <label class="pin_T fs-32">2</label>
                        </div>
                        <div class="pinB" nr="3" @click="onPinPress(3)">
                            <label class="pin_T fs-32">3</label>
                        </div>
                        <div class="pinB" nr="4" @click="onPinPress(4)">
                            <label class="pin_T fs-32">4</label>
                        </div>
                        <div class="pinB" nr="5" @click="onPinPress(5)">
                            <label class="pin_T fs-32">5</label>
                        </div>
                        <div class="pinB" nr="6" @click="onPinPress(6)">
                            <label class="pin_T fs-32">6</label>
                        </div>
                        <div class="pinB" nr="7" @click="onPinPress(7)">
                            <label class="pin_T fs-32">7</label>
                        </div>
                        <div class="pinB" nr="8" @click="onPinPress(8)">
                            <label class="pin_T fs-32">8</label>
                        </div>
                        <div class="pinB" nr="9" @click="onPinPress(9)">
                            <label class="pin_T fs-32">9</label>
                        </div>
                        <div class="pinB"></div>
                        <div class="pinB" nr="0" @click="onPinPress(0)">
                            <label class="pin_T fs-32">0</label>
                        </div>
                        <div class="pinB pDelete" @click="onPinPress('del')">
                            <img src="../../../../../../public/resources/images/delete.png" class="pin_T" style="width: 35%; margin: 0 auto" />
                        </div>
                    </div>
                </div>
                <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '10_forgot_member'" :class="'container_forgot_member is-' + $device">
                <span class="fs-22 fw-600 mb-20">ลืมหมายเลขสมาชิก</span><br />
                <span class="fs-18">กรุณากรอกข้อมูลให้ครบถ้วนเพื่อยืนยันตัวตน</span>
                <a-form :form="form" class="mt-20">
                    <div class="row">
                        <span class="col-xl-12 text-left fs-18 fw-600 black">{{ $t('ชื่อ') }}</span>
                    </div>
                    <div class="row">
                        <div class="col-xl-12">
                            <a-form-item>
                                <a-input
                                    v-decorator="[
                                        'first_name',
                                        {
                                            initialValue: data_check_forgot_member.first_name ? data_check_forgot_member.first_name : '',
                                            rules: [
                                                {
                                                    required: false,
                                                    message: 'The name field is required.',
                                                },
                                            ],
                                        },
                                    ]"
                                />
                            </a-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <span class="col-xl-12 text-left fs-18 fw-600 black">{{ $t('นามสกุล') }}</span>
                    </div>
                    <div class="row">
                        <div class="col-xl-12">
                            <a-form-item>
                                <a-input
                                    v-decorator="[
                                        'last_name',
                                        {
                                            initialValue: data_check_forgot_member.last_name ? data_check_forgot_member.last_name : '',
                                            rules: [
                                                {
                                                    required: false,
                                                    message: 'The last name field is required.',
                                                },
                                            ],
                                        },
                                    ]"
                                />
                            </a-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <span class="col-xl-12 text-left fs-18 fw-600 black">เลขประจำตัวประชาชน (4 หลักสุดท้าย)</span>
                    </div>
                    <div class="row">
                        <div class="col-xl-12">
                            <a-form-item>
                                <a-input-password
                                    v-decorator="[
                                        'citizen_id',
                                        {
                                            initialValue: data_check_forgot_member.citizen_id ? data_check_forgot_member.citizen_id : '',
                                            rules: [
                                                {
                                                    required: false,
                                                    message: 'The citizen id field is required.',
                                                },
                                            ],
                                        },
                                    ]"
                                    :maxLength="4"
                                />
                            </a-form-item>
                        </div>
                    </div>
                </a-form>
                <a-button size="large" class="text-center cancel-btn br-20" style="width: 47.5%" @click="step = '1_member_id'">
                    <span class="fs-18 fw-600">ยกเลิก</span>
                </a-button>
                <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
                <div class="ant-form-explain mt-8 red" v-if="err_forgot_member">{{ err_forgot_member }}</div>
            </div>
            <div v-if="step == '11_request_otp_forgot_member'" :class="'container_forgot_member is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 20px"> ลืมหมายเลขสมาชิก </label><br />
                <label class="fs-18" style="font-weight: 300; margin-bottom: 20px">
                    <strong>กรณีท่านลืมหมายเลขสมาชิก จำเป็นต้องยืนยันตัวตน<br />เพื่อความปลอดภัยของข้อมูล </strong>
                </label>
                <label class="fs-18" style="font-weight: 300; margin-bottom: 20px">
                    <strong>
                        รหัส OTP จะถูกส่งไปยังเบอร์โทรศัพท์
                        <span style="color: blue; display: block; text-align: center" v-if="member.mobile">xxx-xxx-{{ member.mobile }}</span>
                        <span style="color: blue; display: block; text-align: center" v-else>ไม่พบเบอร์มือถือในระบบ</span>
                        <span style="display: block">หากท่านต้องการแก้ไขเบอร์โทรศัพท์ </span>
                        <span style="display: block">กรุณาติดต่อเจ้าหน้าที่ 0-2586-2112 กด 0</span>
                        <span style="display: block">ในวันและเวลาทำการ</span>
                    </strong>
                </label>
                <!-- <div v-if="member.mobile" class="text-center w-50 fs-18" style="margin: 0 auto; line-height: 32px; color: #cc0000; border: 2px solid #cc0000; border-radius: 8px" @click="handleSubmit">
                    <strong>ขอรับ OTP</strong>
                </div> -->
                <a-button size="large" class="text-center cancel-btn br-20" style="width: 47.5%" @click="step = '10_forgot_member'">
                    <span class="fs-18 fw-600">ยกเลิก</span>
                </a-button>
                <a-button v-if="member.mobile" size="large" class="text-center primary-btn" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ขอรับ OTP</span>
                </a-button>
            </div>
            <div v-if="step == '12_confirm_otp_forgot_member'" :class="'container-password is-' + $device">
                <label class="fs-22" style="font-weight: 600; margin-bottom: 40px"> กรุณากรอกรหัส OTP </label>
                <div style="width: 100%">
                    <span
                        class="dot animated"
                        :style="{
                            'margin-left': 0,
                            'background-color': otp.length > 0 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 1 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 2 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 3 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 4 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                    <span
                        class="dot animated"
                        :style="{
                            'background-color': otp.length > 5 ? '#cc0000' : 'transparent',
                        }"
                    ></span>
                </div>
                <div class="pins">
                    <div class="pinC animated bounceInUp">
                        <div class="pinB" nr="1" @click="onPinPress(1)">
                            <label class="pin_T fs-32">1</label>
                        </div>
                        <div class="pinB" nr="2" @click="onPinPress(2)">
                            <label class="pin_T fs-32">2</label>
                        </div>
                        <div class="pinB" nr="3" @click="onPinPress(3)">
                            <label class="pin_T fs-32">3</label>
                        </div>
                        <div class="pinB" nr="4" @click="onPinPress(4)">
                            <label class="pin_T fs-32">4</label>
                        </div>
                        <div class="pinB" nr="5" @click="onPinPress(5)">
                            <label class="pin_T fs-32">5</label>
                        </div>
                        <div class="pinB" nr="6" @click="onPinPress(6)">
                            <label class="pin_T fs-32">6</label>
                        </div>
                        <div class="pinB" nr="7" @click="onPinPress(7)">
                            <label class="pin_T fs-32">7</label>
                        </div>
                        <div class="pinB" nr="8" @click="onPinPress(8)">
                            <label class="pin_T fs-32">8</label>
                        </div>
                        <div class="pinB" nr="9" @click="onPinPress(9)">
                            <label class="pin_T fs-32">9</label>
                        </div>
                        <div class="pinB"></div>
                        <div class="pinB" nr="0" @click="onPinPress(0)">
                            <label class="pin_T fs-32">0</label>
                        </div>
                        <div class="pinB pDelete" @click="onPinPress('del')">
                            <img src="../../../../../../public/resources/images/delete.png" class="pin_T" style="width: 35%; margin: 0 auto" />
                        </div>
                    </div>
                </div>
                <a-button size="large" class="text-center cancel-btn br-20" style="width: 47.5%" @click="goToStep(11)">
                    <span class="fs-18 fw-600">ยกเลิก</span>
                </a-button>
                <a-button size="large" class="text-center primary-btn fs-14" style="width: 47.5%; margin-left: 5%" @click="handleSubmit">
                    <span class="fs-18 color-white fw-600">ยืนยัน</span>
                </a-button>
                <!-- end: section footer -->
            </div>
            <div v-if="step == '13_end_forgot_member'" :class="'container_forgot_password is-' + $device">
                <label class="fs-22" style="margin-bottom: 20px">
                    <span style="display: block">รหัสสมาชิก</span>
                    <span style="display: block">เอสซีจี ดีเบนเจอร์ คลับ</span>
                    <span style="display: block">ของท่านคือ</span> </label
                ><br />
                <label class="fs-20" style="font-weight: 400; margin-bottom: 20px">
                    <strong>{{ member.member_id }}</strong>
                    <input type="hidden" id="member_id" :value="member.member_id" />
                </label>
                <!-- <div class="text-center w-50 fs-16" style="margin: 0 auto; height: 32px; color: #cc0000; border: 2px solid #cc0000; border-radius: 8px; cursor: pointer" @click="copyMember">
                    <strong>คัดลอก</strong>
                </div> -->
                <br />
                <a-button size="large" class="text-center primary-btn fs-14" @click="copyMember">
                    <span class="fs-18 color-white fw-600">คัดลอก</span>
                </a-button>
                <!-- <a-button key="back" class="custom-modal-footer-single-close-btn mt-24" style="width: 50% !important" @click="isBackToPassword">
                    {{ $t('ปิดหน้าต่าง') }}
                </a-button> -->
                <br />
                <a-button size="large" class="text-center cancel-btn br-20 mt-32 w-50" @click="isBackToPassword">
                    <span class="fs-18 fw-600">ปิดหน้านี้</span>
                </a-button>
            </div>
            <modal-form ref="modalForm" :key="modal_visible" :visible="modal_visible" :step="modal_step" :data="modal_data" @on-save="onModalSave" @on-cancel="onModalCancel" />
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import store from 'store';
import axios from 'axios';
import modalForm from './modalForm';
// import navbar from '../../components/navbar';
export default {
    name: 'CuiLogin',
    components: {
        modalForm,
    },
    computed: {
        ...mapState(['settings']),
        loading() {
            return this.$store.state.user.loading;
        },
    },
    data: function () {
        const formItemLayout = {
            labelCol: { span: 12 },
            wrapperCol: { span: 10 },
        };
        const formTailLayout = {
            labelCol: { span: 12 },
            wrapperCol: { span: 10 },
        };
        const labelCol = {
            xs: { span: 24 },
            sm: { span: 12 },
        };
        const wrapperCol = {
            xs: { span: 24 },
            sm: { span: 24 },
        };
        const wrapperCol2 = {
            xs: { span: 24 },
            sm: { span: 24 },
        };
        return {
            /* mode: process.env.NODE_ENV,
      public_path: process.env.VUE_APP_PUBLIC_PATH, */
            form: this.$form.createForm(this),
            formItemLayout,
            formTailLayout,
            labelCol,
            wrapperCol,
            wrapperCol2,
            modal_visible: false,
            modal_data: {},
            step: '1_member_id',
            modal_step: '1_member_id',
            step_check: '',
            member: {},
            username: this.$mode != 'production' ? process.env.VUE_APP_USERNAME : '',
            password: this.$mode != 'production' ? process.env.VUE_APP_PASSWORD : '',
            otp: '',
            new_password: '',
            new_password_confirm: '',
            err_forgot_member: '',
            data_check_forgot_member: {},
            loading_1_member_id: false,
        }; /* step 2_password, 3_forgot_password, 4_otp,
        welcom,policy_popup, welcom_birthday, pin_create,
        pin_success, pin_create, pin_create, pin_create */
    },
    mounted() {},
    methods: {
        isBack() {
            console.log('this.step', this.step);
            if (this.step == '2_password') {
                this.step = '1_member_id';
            } else if (this.step == '3_forgot_password') {
                this.step = '2_password';
            } else if (this.step == '5_create_new_password') {
                this.step = '4_otp';
            } else if (this.step == '6_confirm_new_password') {
                this.step = '5_create_new_password';
            } else if (this.step == '7_id_card') {
                this.step = '1_member_id';
            } else if (this.step == '8_change_pin') {
                this.step = '1_member_id';
            } else if (this.step == '9_confirm_change_pin') {
                this.step = '8_change_pin';
            } else if (this.step == '10_forgot_member') {
                this.goToStep(1);
            } else if (this.step == '11_request_otp_forgot_member') {
                this.step = '10_forgot_member';
            } else if (this.step == '12_confirm_otp_forgot_member') {
                this.otp = '';
                this.step = '11_request_otp_forgot_member';
            } else if (this.step == '13_end_forgot_member') {
                this.step = '1_member_id';
            }
        },
        changeAuthProvider(value) {
            this.$store.commit('CHANGE_SETTING', {
                setting: 'authProvider',
                value,
            });
        },
        handleSubmit(e = null) {
            switch (this.step) {
                case '1_member_id': {
                    // if (!this.$store.state.user.loading) {
                    if (!this.loading_1_member_id) {
                        if (e) e.preventDefault();
                        this.form.validateFields((err, values) => {
                            if (!err) {
                                this.loading_1_member_id = true;
                                var data = { member_id: values.username };
                                this.$store.dispatch('user/CHECK_LOGIN', {
                                    payload: {
                                        data,
                                        callback: (res) => {
                                            console.log('res-------->', res);
                                            if (res && res.data.result == 'errors') {
                                                const error = {
                                                    message: this.$t('Login Fail!'),
                                                };
                                                _.filter(res.data.errors, (v, k) => {
                                                    error.description = v[0];
                                                });
                                                this.modal_visible = true;
                                                this.modal_step = 'custom_without_header';
                                                this.modal_data.message = error.description;
                                            } else {
                                                console.log('success---->');
                                                this.member = res.data.complete;
                                                this.username = values.username;
                                                if (res.data.complete.check_pin) {
                                                    this.goToStep(2);
                                                } else {
                                                    // this.step_check = 'check_pin_false'
                                                    // this.goToStep(4);
                                                    this.goToStep(7);
                                                }
                                            }
                                            this.loading_1_member_id = false;
                                        },
                                    },
                                });
                                // this.$store.dispatch('user/LOGIN', { payload: values });
                                // if (values.username && values.username != '') {
                                //   if (values.username == '00000000000') {
                                //     this.username = values.username;
                                //     this.goToStep(2);
                                //   } else {
                                //     this.modal_visible = true;
                                //     this.modal_step = 'custom_without_header';
                                //     this.modal_data.message = 'ข้อมูลหมายเลขสมาชิกไม่ถูกต้อง';
                                //   }
                                // } else {
                                //   this.modal_visible = true;
                                //   this.modal_step = 'custom_without_header';
                                //   this.modal_data.message = 'กรุณากรอกข้อมูลให้ครบ';
                                // }
                            }
                        });
                    }
                    break;
                }
                case '2_password': {
                    if (e) e.preventDefault();
                    var data = {
                        username: this.username,
                        password: this.password,
                    };
                    this.$store.dispatch('user/LOGIN', {
                        payload: {
                            data,
                            callback: (res) => {
                                if (res && res.data && res.data.result == 'errors') {
                                    const error = {
                                        message: this.$t('Login Fail!'),
                                    };
                                    _.filter(res.data.errors, (v, k) => {
                                        error.description = v[0];
                                    });
                                    this.password = '';
                                    this.modal_visible = true;
                                    this.modal_step = 'custom_without_header';
                                    this.modal_data.message = error.description;
                                    // this.$notification.error(error);
                                } else {
                                    console.log('login success---->');
                                    this.$router.replace({
                                        /* path: '/intro', */
                                        /* path: '/home', */
                                        path: '/welcome',
                                        query: {
                                            popup: res.data.complete.popup,
                                        },
                                    });
                                }
                            },
                        },
                    });
                    // if (this.password.length < 6) {
                    //   this.modal_visible = true;
                    //   this.modal_step = 'custom_without_header';
                    //   this.modal_data.message = 'กรุณากรอก PIN ให้ครบถ้วน';
                    // } else if (this.password != '123456') {
                    //   this.modal_visible = true;
                    //   this.modal_step = 'custom_without_header';
                    //   this.modal_data.message = 'รหัส PIN ของคุณไม่ถูกต้อง';
                    // } else {
                    //   /**
                    //    * CASE: PIN ถูก
                    //    */
                    //   this.$router.replace({
                    //     path: '/intro',
                    //     query: {},
                    //   });
                    // }
                    break;
                }
                case '4_otp': {
                    // if (this.otp.length < 6) {
                    //   this.modal_visible = true;
                    //   this.modal_step = 'custom_without_header';
                    //   this.modal_data.message = 'กรุณากรอก OTP ให้ครบถ้วน';
                    // } else if (this.otp != '123456') {
                    //   this.modal_visible = true;
                    //   this.modal_step = 'custom_without_header';
                    //   this.modal_data.message = 'รหัส OTP ของคุณไม่ถูกต้อง';
                    // } else {
                    //   /**
                    //    * CASE: OTP ถูก
                    //    */
                    //   this.goToStep(5);
                    // }
                    this.goToStep(5);
                    break;
                }
                case '5_create_new_password': {
                    if (this.new_password.length < 6) {
                        this.modal_step = 'custom_without_header';
                        this.modal_data.message = 'กรุณาตั้งรหัสผ่าน PIN ให้ครบ 6 หลัก';
                        this.modal_visible = true;
                    } else {
                        this.goToStep(6);
                    }
                    break;
                }
                case '6_confirm_new_password': {
                    this.$store.dispatch('user/POST', {
                        payload: {
                            path: '/api/ChangePinByOtp',
                            data: {
                                member_id: this.username,
                                otp: this.otp,
                                pin: this.new_password,
                                pin_confirmation: this.new_password_confirm,
                                channel_id: 7,
                            },
                            callback: (res) => {
                                if (res && res.result == 'complete') {
                                    /* this.$confirm({
                                        // message: res.complete.msg, old response เขียนคำผิด
                                        message: 'คุณตั้งรหัส pin สำเร็จ',
                                        button: {
                                            yes: 'ตกลง',
                                        },
                                        callback: (confirm) => {
                                            if (confirm) {
                                                this.goToStep(1);
                                            }
                                        },
                                    }); */
                                    this.modal_step = 'custom_without_header';
                                    this.modal_data.title = 'สร้างรหัส PIN สำเร็จ';
                                    this.modal_data.message = 'ท่านสามารถเข้าสู่ระบบด้วยรหัส PIN ที่สร้างใหม่ได้ทันที';
                                    this.modal_visible = true;
                                } else {
                                    const errors = {
                                        title: '',
                                    };
                                    for (const [key, value] of Object.entries(res.errors)) {
                                        if (key) {
                                            console.log('value[0]', value[0]);
                                            errors.title += value[0];
                                        }
                                    }
                                    this.$confirm({
                                        message: errors.title,
                                        button: {
                                            yes: 'ปิดหน้าต่าง',
                                        },
                                        callback: (confirm) => {},
                                    });
                                }
                            },
                        },
                    });
                    // if (this.new_password_confirm.length < 6) {
                    //   this.modal_visible = true;
                    //   this.modal_step = 'custom_without_header';
                    //   this.modal_data.message = 'กรุณาตั้งรหัสผ่าน PIN ให้ครบ 6 หลัก';
                    // } else if (this.new_password_confirm != this.new_password) {
                    //   this.modal_visible = true;
                    //   this.modal_step = 'custom_without_header';
                    //   this.modal_data.message = 'รหัส PIN ไม่ตรงกัน';
                    // } else {
                    //   this.modal_visible = true;
                    //   this.modal_step = 'custom_without_header';
                    //   this.modal_data.message = 'ไม่สามารถตั้ง PIN ได้';
                    // }
                    break;
                }
                case '7_id_card': {
                    if (!this.$store.state.user.loading) {
                        if (e) e.preventDefault();
                        this.form.validateFields((err, values) => {
                            if (!err) {
                                var data = {
                                    username: this.username,
                                    password: values.card_id,
                                };
                                this.$store.dispatch('user/LOGIN', {
                                    payload: {
                                        data,
                                        callback: (res) => {
                                            if (res && res.data && res.data.result == 'errors') {
                                                const error = {
                                                    description: '',
                                                };
                                                _.filter(res.data.errors, (v, k) => {
                                                    error.description = v[0];
                                                });
                                                this.password = '';
                                                this.modal_visible = true;
                                                this.modal_step = 'custom_without_header';
                                                this.modal_data.message = error.description;
                                                // this.$notification.error(error);
                                            } else {
                                                this.goToStep(8);
                                            }
                                        },
                                    },
                                });
                            }
                        });
                    }
                    break;
                }
                case '8_change_pin': {
                    console.log('test test test');
                    if (this.new_password.length < 6) {
                        this.modal_visible = true;
                        this.modal_step = 'custom_without_header';
                        this.modal_data.message = 'กรุณาตั้งรหัสผ่าน PIN ให้ครบ 6 หลัก';
                    } else {
                        this.goToStep(9);
                    }
                    break;
                }
                case '9_confirm_change_pin': {
                    // var option = {
                    //   headers: {
                    //     Authorization: `Bearer ${store.get('accessTokenCheckPin')}`,
                    //     'content-type': 'application/json;multipart/form-data',
                    //   },
                    //   data: {
                    //     password: this.new_password,
                    //     confirm_password: this.new_password_confirm,
                    //     channel_id: 7,
                    //   },
                    // };
                    // this.$store.dispatch('user/POST', {
                    //   payload: {
                    //     path: '/api/changePin',
                    //     option,
                    //     callback: (res) => {
                    //       if (res && res.result == 'complete') {
                    //         this.$confirm({
                    //           message: 'คุณเปลี่ยน PIN สำเร็จ',
                    //           button: {
                    //             yes: 'ตกลง',
                    //           },
                    //           callback: (confirm) => {
                    //             if (confirm) {
                    //               this.goToStep(1);
                    //             }
                    //           },
                    //         });
                    //       } else {
                    //         const errors = {
                    //           title: '',
                    //         };
                    //         for (const [key, value] of Object.entries(res.errors)) {
                    //           if (key) {
                    //             console.log('value[0]', value[0]);
                    //             errors.title += value[0];
                    //           }
                    //         }
                    //         this.$confirm({
                    //           message: errors.title,
                    //           button: {
                    //             yes: 'ปิดหน้าต่าง',
                    //           },
                    //           callback: (confirm) => {},
                    //         });
                    //       }
                    //     },
                    //   },
                    // });
                    const apiClient = axios.create({
                        baseURL: this.$apiUrl,
                    });
                    apiClient.interceptors.request.use((request) => {
                        const accessTokenCheckPin = store.get('accessTokenCheckPin');
                        console.log('accessTokenCheckPin', accessTokenCheckPin);
                        if (accessTokenCheckPin) {
                            request.headers.Authorization = `Bearer ${accessTokenCheckPin}`;
                        }
                        return request;
                    });
                    apiClient
                        .post(`${this.$apiUrl}/api/changePin`, {
                            password: this.new_password,
                            confirm_password: this.new_password_confirm,
                            channel_id: 7,
                        })
                        .then((res) => {
                            if (res && res.data && res.data.result == 'complete') {
                                store.set('accessToken', store.get('accessTokenCheckPin'));
                                this.$confirm({
                                    message: 'คุณเปลี่ยน PIN สำเร็จ',
                                    button: {
                                        yes: 'ตกลง',
                                    },
                                    callback: (confirm) => {
                                        if (confirm) {
                                            this.goToStep(1);
                                        }
                                    },
                                });
                            } else {
                                const errors = {
                                    title: '',
                                };
                                for (const [key, value] of Object.entries(res.errors)) {
                                    if (key) {
                                        console.log('value[0]', value[0]);
                                        errors.title += value[0];
                                    }
                                }
                                this.$confirm({
                                    message: errors.title,
                                    button: {
                                        yes: 'ปิดหน้าต่าง',
                                    },
                                    callback: (confirm) => {},
                                });
                            }
                        })
                        .catch((err) => err && err.response && err.response.data);
                    break;
                }
                case '10_forgot_member': {
                    if (!this.$store.state.user.loading) {
                        if (e) e.preventDefault();
                        this.form.validateFields((err, values) => {
                            if (!err) {
                                this.err_forgot_member = '';
                                if (/^\s+$/g.test(values.first_name) || !values.first_name || /^\s+$/g.test(values.last_name) || !values.last_name || !values.citizen_id) {
                                    this.err_forgot_member = 'กรุณากรอกข้อมูลให้ครบถ้วน';
                                } else {
                                    this.data_check_forgot_member.first_name = values.first_name;
                                    this.data_check_forgot_member.last_name = values.last_name;
                                    this.data_check_forgot_member.citizen_id = values.citizen_id;
                                    this.$store.dispatch('user/POST', {
                                        payload: {
                                            path: '/api/CheckNameRef',
                                            data: {
                                                first_name: values.first_name,
                                                last_name: values.last_name,
                                                citizen_id: values.citizen_id,
                                            },
                                            callback: (res) => {
                                                console.log(res.result);
                                                if (res && res.result == 'complete') {
                                                    this.member.mobile = res.complete;
                                                    this.goToStep(11);
                                                } else {
                                                    for (const [key, value] of Object.entries(res.errors)) {
                                                        if (key) {
                                                            console.log('value[0]', value[0]);
                                                            this.err_forgot_member += value[0];
                                                        }
                                                    }
                                                }
                                            },
                                        },
                                    });
                                }
                            }
                        });
                    }
                    break;
                }
                case '11_request_otp_forgot_member': {
                    this.$store.dispatch('user/POST', {
                        payload: {
                            path: '/api/GenerateMemberIdOtp',
                            data: {
                                first_name: this.data_check_forgot_member.first_name,
                                last_name: this.data_check_forgot_member.last_name,
                                citizen_id: this.data_check_forgot_member.citizen_id,
                            },
                            callback: (res) => {
                                if (res && res.result == 'complete') {
                                    this.goToStep(12);
                                } else {
                                    const errors = {
                                        title: '',
                                    };
                                    for (const [key, value] of Object.entries(res.errors)) {
                                        if (key) {
                                            console.log('value[0]', value[0]);
                                            errors.title += value[0];
                                        }
                                    }
                                    this.$confirm({
                                        message: errors.title,
                                        button: {
                                            yes: 'ปิดหน้าต่าง',
                                        },
                                        callback: (confirm) => {},
                                    });
                                }
                            },
                        },
                    });
                    break;
                }
                case '12_confirm_otp_forgot_member': {
                    this.$store.dispatch('user/POST', {
                        payload: {
                            path: '/api/GetMemberId',
                            data: {
                                first_name: this.data_check_forgot_member.first_name,
                                last_name: this.data_check_forgot_member.last_name,
                                citizen_id: this.data_check_forgot_member.citizen_id,
                                otp: this.otp,
                            },
                            callback: (res) => {
                                if (res && res.result == 'complete') {
                                    this.member.member_id = res.complete;
                                    this.username = res.complete;
                                    this.goToStep(13);
                                } else {
                                    const errors = {
                                        title: '',
                                    };
                                    for (const [key, value] of Object.entries(res.errors)) {
                                        if (key) {
                                            console.log('value[0]', value[0]);
                                            errors.title += value[0];
                                        }
                                    }
                                    this.$confirm({
                                        message: errors.title,
                                        button: {
                                            yes: 'ปิดหน้าต่าง',
                                        },
                                        callback: (confirm) => {},
                                    });
                                }
                            },
                        },
                    });
                    break;
                }
                default:
                    break;
            }
        },
        generatePinOtp() {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/GeneratePinOtp',
                    data: {
                        member_id: this.username,
                    },
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            this.$confirm({
                                message: res.complete.msg,
                                /* message: 'กรุณากรอก OTP ที่ได้รับผ่าน SMS', */
                                button: {
                                    yes: 'ตกลง',
                                },
                                callback: (confirm) => {},
                            });
                        } else {
                            const errors = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    console.log('value[0]', value[0]);
                                    errors.title += value[0];
                                }
                            }
                            this.$confirm({
                                message: errors.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        }
                    },
                },
            });
        },
        onModalSave() {},
        onModalCancel() {
            this.modal_visible = false;
            this.modal_step = 'custom_without_header';
            this.modal_data = {};
            if (this.step == '6_confirm_new_password') this.goToStep(1);
        },
        onPinPress(pin) {
            switch (this.step) {
                case '2_password': {
                    if (pin == 'del') {
                        this.password = this.password.slice(0, -1);
                    } else {
                        if (this.password.length >= 6) return;
                        this.password += String(pin);
                    }
                    break;
                }
                case '4_otp': {
                    if (pin == 'del') {
                        this.otp = this.otp.slice(0, -1);
                    } else {
                        if (this.otp.length >= 6) return;
                        this.otp += String(pin);
                    }
                    break;
                }
                case '5_create_new_password': {
                    if (pin == 'del') {
                        this.new_password = this.new_password.slice(0, -1);
                    } else {
                        if (this.new_password.length >= 6) return;
                        this.new_password += String(pin);
                    }
                    break;
                }
                case '6_confirm_new_password': {
                    if (pin == 'del') {
                        this.new_password_confirm = this.new_password_confirm.slice(0, -1);
                    } else {
                        if (this.new_password_confirm.length >= 6) return;
                        this.new_password_confirm += String(pin);
                    }
                    break;
                }
                case '8_change_pin': {
                    if (pin == 'del') {
                        this.new_password = this.new_password.slice(0, -1);
                    } else {
                        if (this.new_password.length >= 6) return;
                        this.new_password += String(pin);
                    }
                    break;
                }
                case '9_confirm_change_pin': {
                    if (pin == 'del') {
                        this.new_password_confirm = this.new_password_confirm.slice(0, -1);
                    } else {
                        if (this.new_password_confirm.length >= 6) return;
                        this.new_password_confirm += String(pin);
                    }
                    break;
                }
                case '12_confirm_otp_forgot_member': {
                    if (pin == 'del') {
                        this.otp = this.otp.slice(0, -1);
                    } else {
                        if (this.otp.length >= 6) return;
                        this.otp += String(pin);
                    }
                    break;
                }
                default:
                    break;
            }
        },
        goToStep(step) {
            switch (step) {
                case 1: {
                    // this.username = '';
                    this.password = '';
                    this.otp = '';
                    this.new_password = '';
                    this.new_password_confirm = '';
                    this.data_check_forgot_member = {};
                    this.form.resetFields();
                    this.step = '1_member_id';
                    break;
                }
                case 2: {
                    this.step = '2_password';
                    this.modal_step = '2_password';
                    // this.modal_visible = true;
                    break;
                }
                case 3: {
                    this.password = '';
                    this.otp = '';
                    this.new_password = '';
                    this.new_password_confirm = '';
                    this.step = '3_forgot_password';
                    break;
                }
                case 4: {
                    this.step = '4_otp';
                    this.generatePinOtp();
                    break;
                }
                case 5: {
                    this.step = '5_create_new_password';
                    break;
                }
                case 6: {
                    this.step = '6_confirm_new_password';
                    break;
                }
                case 7: {
                    this.step = '7_id_card';
                    break;
                }
                case 8: {
                    this.step = '8_change_pin';
                    break;
                }
                case 9: {
                    this.step = '9_confirm_change_pin';
                    break;
                }
                case 10: {
                    this.err_forgot_member = '';
                    this.step = '10_forgot_member';
                    break;
                }
                case 11: {
                    this.otp = '';
                    this.step = '11_request_otp_forgot_member';
                    break;
                }
                case 12: {
                    this.step = '12_confirm_otp_forgot_member';
                    break;
                }
                case 13: {
                    this.step = '13_end_forgot_member';
                    break;
                }
                default:
                    break;
            }
        },
        copyMember() {
            var testingCodeToCopy = document.querySelector('#member_id');
            testingCodeToCopy.setAttribute('type', 'text');
            testingCodeToCopy.select();
            var successful = document.execCommand('copy');
            console.log('successful', successful);
            /* unselect the range */
            testingCodeToCopy.setAttribute('type', 'hidden');
            window.getSelection().removeAllRanges();
        },
        isBackToPassword() {
            var data = { member_id: this.username };
            this.$store.dispatch('user/CHECK_LOGIN', {
                payload: {
                    data,
                    callback: (res) => {
                        if (res && res.data.result == 'errors') {
                            const error = {
                                message: this.$t('Login Fail!'),
                            };
                            _.filter(res.data.errors, (v, k) => {
                                error.description = v[0];
                            });
                            this.modal_visible = true;
                            this.modal_step = 'custom_without_header';
                            this.modal_data.message = error.description;
                        } else {
                            console.log('success---->');
                            this.member = res.data.complete;
                            if (res.data.complete.check_pin) {
                                this.goToStep(2);
                            } else {
                                this.goToStep(7);
                            }
                        }
                    },
                },
            });
        },
    },
};
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
<style scoped>
.navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    /* height: 40px; */
    /* height: 10vh; */
    height: 48px;
    padding: 0 8px;
    z-index: 2;
}
.custom-close {
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.pins {
    /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
    border-radius: 12px;
    background-color: #fff !important;
    height: calc(220px * 4 / 3);
    margin: 16px 0;
}
.center2 {
    text-align: center;
}
.pinRC {
    display: none;
}
.pinC {
    display: block;
    position: relative;
    width: 270px;
    height: 220px;
    margin: 0 auto;
}
.pinC > .pinB {
    position: relative;
    float: left;
    width: calc(270px / 3);
    height: calc(220px / 3);
    text-align: center;
    /* line-height: 3; */
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB:not(.empty) {
    /* background-color: #dcdcdc; */
    /* background-color: transparent; */
    /* border: 2px solid #ffffff; */
}
.pinC > .pinB:not(.empty):hover {
    /*     border: 2px dotted #fefefe; */
    cursor: pointer;
}
.pinC > .pinB:not(.empty)::before {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(100, 100, 100, 0);
    /* background-color: transparent; */
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB:not(.empty):active::before {
    background-color: rgba(200, 200, 200, 0.45);
}
.pinC > .pinB > .pin_T {
    /* position: absolute;
  width: 100%;
  left: 0%;
  height: 100%; */
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.pin_T.pDelete {
    font-weight: 300 !important;
}
.pinC > .pinB > .pin_t {
    /* font-size: 75%; */
    position: absolute;
    bottom: -5px;
    left: 50%;
    color: darkgrey;
    transform: translate(-50%, 0);
}
.pinC > .pinB.input > .pinpart {
    border: 2px solid #000000;
    border-radius: 50%;
    float: left;
    width: 10px;
    height: 10px;
    position: relative;
    top: calc(50% - 5px);
    margin-left: 4.5px;
    background-color: rgba(100, 100, 100, 0);
    /* background-color: transparent; */
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB.input > .pinpart.active {
    background-color: #000000;
}
.confirmed {
    animation: removec ease-out 1s;
    animation-iteration-count: 1;
    transform-origin: 0% 50%;
    animation-fill-mode: forwards;
    /*when the spec is finished*/
    -webkit-animation: removec ease-out 1s;
    -webkit-animation-iteration-count: 1;
    -webkit-transform-origin: 0% 50%;
    -webkit-animation-fill-mode: forwards;
    /*Chrome 16+, Safari 4+*/
    -moz-animation: removec ease-out 1s;
    -moz-animation-iteration-count: 1;
    -moz-transform-origin: 0% 50%;
    -moz-animation-fill-mode: forwards;
    /*FF 5+*/
    -o-animation: removec ease-out 1s;
    -o-animation-iteration-count: 1;
    -o-transform-origin: 0% 50%;
    -o-animation-fill-mode: forwards;
    /*Not implemented yet*/
    -ms-animation: removec ease-out 1s;
    -ms-animation-iteration-count: 1;
    -ms-transform-origin: 0% 50%;
    -ms-animation-fill-mode: forwards;
    /*IE 10+*/
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
@keyframes removec {
    0% {
        opacity: 1;
        transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        transform: translate(0px, 0px) scaleX(0);
    }
}
@-moz-keyframes removec {
    0% {
        opacity: 1;
        -moz-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -moz-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -moz-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -moz-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -moz-transform: translate(0px, 0px) scaleX(0);
    }
}
@-webkit-keyframes removec {
    0% {
        opacity: 1;
        -webkit-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -webkit-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -webkit-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -webkit-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -webkit-transform: translate(0px, 0px) scaleX(0);
    }
}
@-o-keyframes removec {
    0% {
        opacity: 1;
        -o-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -o-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -o-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -o-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -o-transform: translate(0px, 0px) scaleX(0);
    }
}
@-ms-keyframes removec {
    0% {
        opacity: 1;
        -ms-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -ms-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -ms-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -ms-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -ms-transform: translate(0px, 0px) scaleX(0);
    }
}
.dots-width {
    width: 100%;
    margin: 0 auto;
}
.dot {
    border: 1px solid #bbb;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-left: 20px;
}
.footer-label {
    padding: 0;
    margin-top: 12px;
}
.เข้าใช้งานด้วยหมายเลขสมาชิกอื่น {
    text-align: center;
    width: 100%;
}
.ลืมรหัส {
    text-align: center;
    width: 100%;
}
.container-password {
    padding: 20px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    width: 360px;
    /* background-color: #fff !important; */
    border-radius: 12px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
/* .container-password.is-mobile {
    width: 100%;
} */
.container_forgot_password {
    padding: 20px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    width: 360px;
    background-color: #fff !important;
    border-radius: 12px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
/* .container_forgot_password.is-mobile {
    width: 100%;
} */
.container_forgot_member {
    padding: 20px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    width: 360px;
    background-color: #fff !important;
    border-radius: 12px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
/* .container_forgot_member.is-mobile {
    width: 100%;
} */
.vc-overlay {
    left: -50vw !important;
    top: -50vh !important;
}
@media (max-device-width: 480px) {
    .container-password {
        width: 100%;
    }
    .container_forgot_password {
        width: 100%;
    }
    .container_forgot_member {
        width: 100%;
    }
    .vc-overlay {
        left: -7vw !important;
    }
}
@media (max-device-width: 413px) {
    .pinC {
        width: 270px;
        height: 220px;
    }
    .pinC > .pinB {
        width: calc(270px / 3);
        height: calc(220px / 3);
    }
    .pins {
        height: calc(220px * 4 / 3);
    }
    /* .pinC > .pinB > .pin_T {
        font-size: 25px;
    } */
    .container-password {
        width: 330px;
    }
    .container_forgot_member {
        width: 330px;
    }
}
@media (max-device-width: 374px) {
    .dots-width {
        width: 80%;
    }
    .dot {
        width: 15px;
        height: 15px;
        margin-left: 10px;
    }
    .pinC {
        width: 250px;
        height: 200px;
    }
    .pinC > .pinB {
        width: calc(250px / 3);
        height: calc(200px / 3);
    }
    .pins {
        height: calc(200px * 4 / 3);
    }
    /* .pinC > .pinB > .pin_T {
        font-size: 25px;
    } */
    .container-password {
        width: 280px;
    }
    .container_forgot_member {
        width: 280px;
    }
}
@media screen and (max-width: 1200px) {
    .col-xl-6 {
        width: 50%;
    }
}
</style>